import React, { useEffect, useState } from "react";
import { Button, Icon, Pagination, Modal, Confirm } from "semantic-ui-react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import "../../components/athletes/AdvocateList.css";
import { Redirect } from "react-router-dom";
import Add from "../../components/layout/Slideshow/Add";
import Reorder from "../../components/layout/Slideshow/Reorder";
import Card from "../../components/layout/Slideshow/Card";
import "./SuperSlideshow.css";
import "../About.css";

const SuperSlideshowList = (props) => {
  // defining States & Dispatch
  const [data, setData] = useState([]);
  const [dataOrder, setDataOrder] = useState([]);
  const [add, setAdd] = useState(false);
  const [images, setImages] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [reOrder, setReOrder] = useState(false);
  const [save, setSave] = useState(false);

  // Open and Close Add Skill Modal

  // Pagination

  const pageChange = (not, data) => {
    setActivePage(data.activePage);
  };

  // Getting Data From Props to save it in the State
  useEffect(() => {
    if (props.slideshow) {
      setData(props.slideshow);
    }
  }, [props.slideshow]);
  useEffect(() => {
    if (props.slideshowOrder) {
      setDataOrder(props.slideshowOrder);
    }
  }, [props.slideshowOrder]);

  useEffect(() => {
    const order = dataOrder?.order?.order;
    if (order && order.length > 0) {
      let storingObject = Object.keys(data);
      let imagesArray = [];
      if (storingObject.length > 0) {
        imagesArray = order.map((key) => {
          return data[key];
        });
      }

      setTotalPages(Math.ceil(imagesArray.length / 6));
      const paginated =
        imagesArray && imagesArray.slice((activePage - 1) * 6, activePage * 6);
      setImages(paginated);
    } else setImages([]);
  }, [data, activePage, dataOrder]);
  // Delete Functionality (Currently it is deleting from firestore not from firebase)

  // Some Buttons
  let card;
  if (!props.superAdmin) {
    return <Redirect to="/about" />;
  } else {
    if (images.length > 0) {
      card = images.map((image) => {
        return <Card image={image} admin />;
      });
    } else {
      card = (
        <div className="single">
          <p className="not-found cu-center">There is No Data Right Now</p>
        </div>
      );
    }
  }

  return (
    <div className="HomeContainer show-slides-main">
      <div className="SkillsList">
        <h1>Slideshow List</h1>
        <div
          className={
            reOrder
              ? "btn-data with-flex j-center small-mb"
              : "btn-data with-flex j-center"
          }
        >
          {!reOrder && (
            <Button
              className="d-small-hidden"
              icon
              labelPosition="left"
              color="blue"
              name="AddRearrange"
              onClick={() => setReOrder(true)}
            >
              <Icon name="sort numeric up" />
              Rearrange
            </Button>
          )}
          {reOrder && (
            <>
              <Button
                icon="check"
                labelPosition="left"
                color="green"
                name="saveButton"
                content="Save"
                onClick={() => setSave(true)}
              />
              <Button
                className="d-small-hidden"
                icon="close"
                labelPosition="left"
                color="red"
                name="AddRearrange"
                onClick={() => setReOrder(false)}
                content="Close"
              />
            </>
          )}
          {!reOrder && (
            <Button
              icon
              labelPosition="left"
              color="teal"
              name="AddSkillButton"
              onClick={() => setAdd(!add)}
            >
              <Icon name="plus" />
              Add
            </Button>
          )}
        </div>
        {reOrder ? (
          <>
            {images.length && (
              <Reorder
                data={images}
                save={save}
                handleSaveOff={() => setSave(false)}
                close={() => setReOrder(false)}
              />
            )}
          </>
        ) : (
          <div className="team-section show-slides-cards small-p0">
            {images.length > 0 && card}
          </div>
        )}
        {images.length < 1 && <div className="team-section one">{card}</div>}
        {/* pagination and pages show */}
        {totalPages > 1 && !reOrder && (
          <div className="AthleteSearchDetail AthletePagination">
            <Pagination
              onPageChange={pageChange}
              defaultActivePage={1}
              firstItem={null}
              lastItem={null}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{ content: <Icon name="angle right" />, icon: true }}
              pointing
              secondary
              totalPages={totalPages}
            />
          </div>
        )}
      </div>
      {add && <Add open={add} close={() => setAdd(false)} />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    slideshow: state.firestore.data.slideshow,
    slideshowOrder: state.firestore.data.slideshowOrder,
    superAdmin: state.auth.superAdmin,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "slideshow",
    },
    {
      collection: "slideshowOrder",
    },
  ])
)(SuperSlideshowList);
